module.exports = "<div class=\"main-header d-flex justify-content-center\">\r\n    <div class=\"title\">Spellbook</div>\r\n</div>\r\n<app-spell-dashboard></app-spell-dashboard>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main